module.exports = __webpack_public_path__ + "static/img/6.1bea44c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6.jpg
// module id = k9Qt
// module chunks = 57